import { Reducer } from 'redux';
import {
  LoginState,
  LoginActionTypes,
  LOGIN_INPROGRESS,
  LOGIN_SUCCESS,
  TokenResult,
  LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  FEATURE_FLAGS_SUCCESS,
  LOGIN_MODAL_OPEN,
  LOGIN_MODAL_CLOSE,
} from './types';
import { TokenService } from '$/services';
import * as Bixby from '$/core';

const initialState: LoginState = {
  authenticated: false,
  isLoading: false,
  token: '',
  decodedToken: undefined,
  error: '',
  featureFlags: undefined,
  isRefreshModalOpen: false,
};

const loginReducer: Reducer<LoginState> = (state = initialState, action: LoginActionTypes): LoginState => {
  switch (action.type) {
    case LOGIN_INPROGRESS:
      return {
        ...state,
        authenticated: false,
        isLoading: true,
        error: '',
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        authenticated: true,
        isLoading: false,
        token: ((action.payload || {}) as TokenResult).token,
        decodedToken: TokenService.decodeToken(((action.payload || {}) as TokenResult).token),
        error: '',
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        authenticated: false,
        isLoading: false,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
      };
    case LOGIN_MODAL_OPEN:
      return {
        ...state,
        isRefreshModalOpen: true,
      };
    case LOGIN_MODAL_CLOSE:
      return {
        ...state,
        isRefreshModalOpen: false,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        authenticated: false,
        isLoading: false,
        token: '',
        decodedToken: undefined,
        error: Bixby.API.getErrorMessage((action.payload || {}) as Error),
      };
    case FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        featureFlags: action.payload,
      };
    default:
      return state;
  }
};
export default loginReducer;
